// Survey ID to Name mapping
// This can be easily updated with actual survey names
export const surveyMapping = {
  // Example mapping - replace with actual survey names
  '622b2280-16ae-11f0-94ea-9574364caebe': 'Enterprises Readiness Assessment Survey',
  // Add more survey mappings here as needed
  // 'survey-id-2': 'Survey Name 2',
  // 'survey-id-3': 'Survey Name 3',
};

/**
 * Get survey name by ID
 * @param {string} surveyId - The survey ID
 * @returns {string|null} Survey name or null if not found
 */
export const getSurveyName = (surveyId) => {
  return surveyMapping[surveyId] || null;
};

/**
 * Get all survey mappings
 * @returns {Object} All survey mappings
 */
export const getAllSurveyMappings = () => {
  return { ...surveyMapping };
}; 